import React from "react";

const OXXO = (props) => (
  <svg width={32} height={32} xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fillRule="nonzero" fill="none">
      <path
        d="M1.003 9.856c0-1.002.804-1.815 1.798-1.815h26.387c.993 0 1.799.813 1.799 1.815v11.482a1.807 1.807 0 01-1.799 1.814H2.801a1.806 1.806 0 01-1.798-1.814V9.856z"
        fill="#FFF"
      />
      <path
        d="M1.023 9.673c0-.922.741-1.67 1.655-1.67h26.66c.913 0 1.653.748 1.653 1.67v.053H1.023v-.053zm29.968 11.816v.042c0 .921-.74 1.669-1.654 1.669H2.677a1.662 1.662 0 01-1.654-1.67v-.04h29.968z"
        fill="#FBB110"
      />
      <path
        d="M21.763 15.584c0 2.333 1.874 4.224 4.187 4.224 2.311 0 4.186-1.891 4.186-4.224 0-2.334-1.875-4.226-4.186-4.226-2.313 0-4.187 1.892-4.187 4.226zm-19.96 0c0 2.333 1.875 4.224 4.188 4.224 2.311 0 4.186-1.891 4.186-4.224 0-2.334-1.875-4.226-4.186-4.226-2.313 0-4.188 1.892-4.188 4.226zm29.188 5.105H10.349c.372-.263.718-.624 1.096-1.11l2.103-2.708.918 1.171 1.022-1.372-.893-1.148 2.14-2.756c.68-.875-.62-1.902-1.3-1.028l-1.891 2.437-1.923-2.47c-.68-.871-1.978.159-1.297 1.032l2.173 2.786-2.351 3.028c-.836 1.076-1.67 2.062-3.325 2.138H1.023V10.525h20.534c-.353.26-.686.61-1.048 1.075l-2.102 2.707-.919-1.17-1.021 1.372.894 1.147-2.141 2.757c-.68.874.62 1.902 1.3 1.027l1.891-2.436 1.923 2.469c.68.872 1.978-.158 1.297-1.03l-2.173-2.788 2.352-3.027c.767-.99 1.534-1.903 2.938-2.103h6.243V20.69zm-7.548-5.105c0-1.398 1.123-2.53 2.507-2.53 1.384 0 2.505 1.132 2.505 2.53 0 1.396-1.121 2.529-2.505 2.529s-2.507-1.133-2.507-2.53zm-19.959 0c0-1.398 1.122-2.53 2.507-2.53 1.383 0 2.505 1.132 2.505 2.53 0 1.396-1.122 2.529-2.505 2.529-1.385 0-2.507-1.133-2.507-2.53"
        fill="#E70020"
      />
    </g>
  </svg>
);

export default OXXO;
